import React from 'react'

import { Card, Typography, Paper, CardContent, Grid, Stack, CardMedia } from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';
import CarIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import Caravan from "../assets/images/caravan.png";

export default function MobileLibrary() {

    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        iconCenter: {
            width: 100,
            height: 100,
            marginBottom: 5,
            display: "flex",
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        cardStyle: {
            opacity: 0.9,
            minHeight: 0,
            width: 95,
            height: 95,
            marginBottom: 5,
            textAlign: "center",
            '@media only screen and (max-width: 900px)': {
                width: 70,
                height: 70
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        labelSmall: {
            paddingBottom: 3
        },
        bodyText: {
            fontFamily: "Helvetica Neue",
            paddingBottom: 4,
            marginTop: 1,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 2
            }
        },
        textInstruction: {
            paddingTop: 2
        },
        textPenalty: {
            textAlign: "center",
            paddingBottom: 1
        }
    }

    return (
        <Box>
            <SEO title="Mobile Library - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Typography sx={style.typography} variant="h4" color="default">Mobile Library</Typography>
                    <Stack direction="row" alignItems="center">
                        <CarIcon sx={{ fontSize: 100 }} />
                        <Stack direction="column" sx={{ paddingTop: 3 }}>
                            <Typography variant='h5' sx={{ fontWeight: "bold" }}>Schedule of Routes</Typography>
                            <Typography sx={style.bodyText} variant="body1" color="default" align="justify">
                                The Baliwag Mobile Library is one of the programs the Library launched in 2020.
                                It is a roaming library that aims to extend the service of the
                                Library to all the barangays of the town.
                            </Typography>
                        </Stack>
                    </Stack>

                    <Box sx={{ flexGrow: 1, paddingBottom: 4 }}>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={12}>
                            <Grid item sm={12} lg={6}>
                                <Card sx={{ height: 307, boxShadow: 0 }}>
                                    <CardMedia
                                        component="img"
                                        image={Caravan} />
                                </Card>
                            </Grid>
                            <Grid item sm={12} lg={6}>
                                <Card variant="outlined" sx={{ height: 300, paddingBottom: 1 }}>
                                    <CardContent >
                                        <Typography variant="body2" sx={{ ...style.textPenalty, fontWeight: "bold", textAlign: "left" }}>
                                            Weekly Route
                                        </Typography>
                                        <Grid container columns={12} sx={{ paddingTop: 5 }}>
                                            <Grid item xs={12}>
                                                <Typography variant="body2" sx={{ ...style.textPenalty, fontStyle: "italic" }}>
                                                    Due to the risk of the ongoing pandemic, the mobile library is currently postponed.
                                                    Please wait for further updates.
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <Box sx={{ height: 100 }} />
            </Paper>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
        </Box>
    )
}
